import { useContext } from "react"

import styled from "styled-components"

import { IsoLocale, PrivacyLinks } from "@izettle/constants"
import { TranslatorContext, useMarkdown } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text } from "@izettle/react"

const PrivacyPolicyNotice = styled(Text.RegularSecondary)`
  margin-top: ${spacing.small};
  margin-bottom: ${spacing.none};
`

export const Disclaimer = () => {
  const { translator } = useContext(TranslatorContext)
  const { mdElement } = useMarkdown()

  const privacyNotice =
    translator.locale === IsoLocale.esMX
      ? "UPDATED_PRIVACY_POLICY_NOTICE_MX_US"
      : "UPDATED_PRIVACY_POLICY_NOTICE"
  const privacyLink = PrivacyLinks.get(translator.locale)

  return (
    <PrivacyPolicyNotice as="div">
      {mdElement(privacyNotice, {
        replacements: [privacyLink],
        textKey: true,
      })}
    </PrivacyPolicyNotice>
  )
}
